import { Colors } from '../../config/theme';
import LargeLetter from '../../assets/images/svg/LargeLetter';
import Parcel from '../../assets/images/svg/Parcel';
import SmallLetter from '../../assets/images/svg/SmallLetter';
import SmallParcel from '../../assets/images/svg/SmallParcel';

export enum FLOW_TYPE {
  ManagementNewTemplate,
  ManagementUpdateTemplate,
  ManagementDuplicateTemplate,

  StoreNewListing,
  StoreUpdateListing,
  StoreNewListingUsingTemplate,
  StoreUpdateTemplate,
  StoreNewListingUsingDraft,
}

export const FLOW_TYPE_MAPPING = {
  [FLOW_TYPE.ManagementNewTemplate]: 'Management New Template',
  [FLOW_TYPE.ManagementUpdateTemplate]: 'Management Update Template',
  [FLOW_TYPE.ManagementDuplicateTemplate]: 'Management Duplicate Template',

  [FLOW_TYPE.StoreNewListing]: 'Store New Listing',
  [FLOW_TYPE.StoreNewListingUsingTemplate]: 'Store New Listing Using Template',
  [FLOW_TYPE.StoreNewListingUsingDraft]: 'Store New Listing Using Draft',
  [FLOW_TYPE.StoreUpdateTemplate]: 'Store Update Template',
  [FLOW_TYPE.StoreUpdateListing]: 'Store Update Listing',
};

export const STEPS = {
  SET_UP: 0,
  ITEM_INFORMATION: 1,
  MEDIA: 2,
  SPECIFICATIONS: 3,
  COMBINATIONS_TABLE: 4,
  SHIPPING: 5,
  PREVIEW: 6,
};
export const SHARED = {
  draft: 'draft',
  draft_message: 'Save as draft',
  template: 'template',
  template_message: 'Save as template',
  listing: 'public_listing',
  listing_message: 'Publish listing',
};
export const MAXIMUM_IMAGE_FOR_LISTING = 60;
export const TEMPLATE_CONSTANTS = {
  listing_type: 'template',
  main_title: 'Create New Template',
};
export const LISTING_CONSTANTS = {
  listing_type: 'public_listing',
  main_title: 'Create New Listing',
};

const small_letter = {
  name: 'Small Letter',
  weight: 100,
  width: 24,
  height: 5,
  length: 16.5,
  image: <SmallLetter width="50px" height="50px" active={false} />,
};

const large_letter = {
  name: 'Large Letter',
  width: 35,
  weight: 250,
  height: 12,
  length: 25,
  image: <LargeLetter width="50px" height="50px" active={false} />,
};
const small_parcel = {
  name: 'Small Parcel',
  weight: 500,
  width: 45,
  height: 16,
  length: 35,
  image: <SmallParcel width="50px" height="50px" active={false} />,
};
const parcel = {
  name: 'Parcel',
  weight: 1000,
  width: 45,
  height: 45,
  length: 45,
  image: <Parcel width="50px" height="50px" active={false} />,
};

const custom = {
  name: 'Custom',
  width: 300,
  weight: 500,
  height: 300,
  length: 300,
  image: null,
};

export const DeliveryCost = 2.0;

export const all_packages_list = [
  { ...small_letter },
  { ...large_letter },
  { ...small_parcel },
  { ...parcel },
  { ...custom },
];

export function determinePackageType(
  width: number,
  height: number,
  length: number,
) {
  if (width === 24 && height === 5 && length === 16.5) {
    return small_letter;
  } else if (width === 35 && height === 12 && length === 25) {
    return large_letter;
  } else if (width === 45 && height === 16 && length === 35) {
    return small_parcel;
  } else if (width === 45 && height === 45 && length === 45) {
    return parcel;
  } else {
    return custom;
  }
}

export const PackageImageMap = (
  type: string,
  width: number,
  height: number,
  active: boolean,
) => {
  const packageType = determinePackageType(width, height, 0);
  switch (type) {
    case 'Small Letter':
      return <SmallLetter width={width} height={height} active={active} />;
    case 'Large Letter':
      return <LargeLetter width={width} height={height} active={active} />;
    case 'Small Parcel':
      return <SmallParcel width={width} height={height} active={active} />;
    case 'Parcel':
      return <Parcel width={width} height={height} active={active} />;
    default:
      return packageType.image;
  }
};

export const RequiredSign = () => {
  return <span style={{ color: Colors.brightRed }}>*</span>;
};

export const FIELD_CHAR_LENGTH = {
  ARABIC_NAME: 128,
  ENGLISH_NAME: 128,
  ARABIC_DESCRIPTION: 8192,
  ENGLISH_DESCRIPTION: 8192,
};

export const EN_AR_TRANSLATION_SPLIT_CHAR = '**';
